<template>
  <el-main class="common-main">
    <div class="container">
      <el-row class="tac" :gutter="20">
        <el-col :span="4">
          <TheLeft></TheLeft>
        </el-col>
        <el-col :span="20">
          <div class="order-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="全部答疑" name="0"></el-tab-pane>
              <el-tab-pane label="待反馈" name="1"></el-tab-pane>
              <el-tab-pane label="已完成" name="2"></el-tab-pane>
            </el-tabs>
            <div class="order-box" v-loading="loading">
              <div class="order-list" v-if="problems.length > 0">
                <div class="order-item" v-for="(item, index) in problems" :key="index">
                  <div class="order-item-header">
                    <div>编号：{{ item.id }}</div>
                    <div class="order-item-desc">
                      <span>{{ item.created_at }}</span>
                      <span class="order-item-look-desc" @click="goDetail(item.id)">查看详情</span>
                    </div>
                    <i class="el-icon-error order-item-close" @click="deleteProblem(index)"></i>
                  </div>
                  <div class="order-item-content problem-line">
                    <el-row :gutter="20">
                      <el-col :span="3">
                        <span class="problem-tag">答疑试题</span>
                      </el-col>
                      <el-col :span="21">
                        {{ item.topic ? item.topic.title : '该题目不存在或已删除' }}
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" class="problem-part" v-if="item.part">
                      <el-col :span="3">
                        <span class="problem-tag problem-part-tag">子题题目</span>
                      </el-col>
                      <el-col :span="21">
                        {{ item.part.title ? item.part.title : '子题题目不存在或已删除' }}
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" class="problem-user">
                      <el-col :span="3">
                        <span class="problem-tag">我的答疑</span>
                      </el-col>
                      <el-col :span="21">
                        {{ item.problem }}
                      </el-col>
                    </el-row>
                  </div>
                  <div class="order-item-content">
                    <el-row :gutter="20">
                      <el-col :span="3">
                        <span class="problem-tag">答疑反馈</span>
                      </el-col>
                      <el-col :span="21">
                        {{ item.status ? item.reply : '等待反馈' }}
                      </el-col>
                      <div class="problem-reply_at" v-if="item.reply_at">
                        回复时间：{{ item.reply_at }}
                      </div>
                    </el-row>
                  </div>
                </div>
              </div>
              <div class="empty" v-if="page_meta.total === 0">
                <div>
                  <img src="../../static/images/empty.png" alt="暂无数据" class="empty-img">
                  <div class="empty-title">暂无数据</div>
                </div>
              </div>
            </div>
            <div class="list-pagination" v-if="problems.length > 0">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="page_meta.per_page"
                  :total="page_meta.total">
              </el-pagination>
            </div>
            <div class="my-ask">
              <el-button type="default" size="mini" @click="clearProblem">清空答疑</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-main>
</template>

<script>
import TheLeft from "@/components/layouts/TheLeft";
import {authRequest} from "@/utils/request";

export default {
  name: "userProblem",
  head: {
    title: "我的答疑"
  },
  components: {
    TheLeft
  },
  data() {
    return {
      activeName: '0',
      path: process.env.VUE_APP_FILE,
      noneImg: process.env.VUE_APP_NONE,
      problems: [],
      page: 1,
      page_meta: [],
      loading: false
    }
  },
  created() {
    this.getProblems()
  },
  methods: {
    handleClick(tab, event) {
      this.getProblems(true)
    },
    async getProblems(reset = false) {
      this.loading = true
      if (reset) {
        this.page = 1
      }
      try {
        let response = await authRequest('user/problem', {
          method: 'GET',
          params: {
            page: this.page,
            type: this.activeName
          }
        })
        console.log(response)
        let problems = response.data
        this.problems = problems.data
        this.page_meta = problems.meta
        this.loading = false
      } catch (e) {

      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.getProblems()
    },
    deleteProblem(index) {
      this.$confirm('确认要删除该答疑记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        let id = this.problems[index].id
        try {
          await authRequest('problem/' + id, {
            method: 'DELETE'
          })
          this.$message.success('删除成功')
          this.problems.splice(index, 1)
        } catch (e) {

        }
      }).catch(() => {

      });
    },
    goDetail(id) {
      this.$router.push({
        path: '/problem/' + id
      })
    },
    clearProblem() {
      this.$confirm('您确定要清除所有答疑吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        try {
          await authRequest('problem/clear/all', {
            method: 'POST'
          })
          this.$message.success('清除成功')
          this.getProblems()
        } catch (e) {

        }
      }).catch(() => {

      });
    }
  }
}
</script>

<style scoped>
.order-content {
  background-color: #ffffff;
  padding: 10px 20px;
  position: relative;
}

.order-item {
  border: 1px solid #ebebeb;
  margin-bottom: 20px;
  border-radius: 5px;
}

.order-item-header {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  font-size: 14px;
  border-bottom: 1px solid #ebebeb;
  background-color: #f3f3f3;
  position: relative;
}

.order-box {
  min-height: 400px;
}

.order-item-content {
  padding: 20px;
  font-size: 14px;
}

.order-item-footer-status span {
  margin-left: 20px;
}

.problem-tag {
  background-color: #2aacb2;
  padding: 2px 5px;
  border-radius: 3px;
  color: #ffffff;
}

.problem-line {
  border-bottom: 1px solid #ebebeb;
}

.problem-reply_at {
  text-align: right;
  margin-top: 5px;
}

.problem-user {
  margin-top: 10px;
}

.order-item-close {
  position: absolute;
  right: -5px;
  top: -5px;
  font-size: 20px;
  color: #6e6e6e;
  cursor: pointer;
}

.order-item-close:hover {
  color: #F56C6C;
}

.problem-part {
  margin-top: 5px;
}

.problem-part-tag {
  background-color: #F56C6C;
}

.order-item-desc {
  color: #555555;
  font-size: 13px;
}

.order-item-look-desc {
  cursor: pointer;
  margin-left: 10px;
}

.order-item-look-desc:hover {
  color: #2aacb2;
}

.my-ask {
  position: absolute;
  right: 20px;
  top: 10px;
}
</style>
